import { createElementBlock as o, openBlock as l, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(d, e) {
  return l(), o("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.051 1C6.292 1 5 2.52 5 4.222v15.556C5 21.48 6.292 23 8.051 23h7.898C17.708 23 19 21.48 19 19.778V4.222C19 2.52 17.708 1 15.949 1zM7 4.222C7 3.47 7.545 3 8.051 3h7.898C16.456 3 17 3.47 17 4.222v15.556C17 20.53 16.456 21 15.949 21H8.05C7.545 21 7 20.53 7 19.778zM12 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_phone-ByMlw80q.js.map
